import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";

export const useAuthCache = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleLogin = () => {
      // Clear all ping-related queries on login to prevent data leakage between users
      queryClient.removeQueries({
        queryKey: ["ping"],
      });
    };

    const handleLogout = () => {
      // Clear all ping-related queries on logout to prevent data persistence
      queryClient.removeQueries({
        queryKey: ["ping"],
      });
    };

    window.addEventListener("auth:login", handleLogin);
    window.addEventListener("auth:logout", handleLogout);

    return () => {
      window.removeEventListener("auth:login", handleLogin);
      window.removeEventListener("auth:logout", handleLogout);
    };
  }, [queryClient]);
};
